// extracted by mini-css-extract-plugin
export default {"root":"Input_root__o4i5+","customSize":"Input_customSize__qOrxn","disabledInput":"Input_disabledInput__ZPvTY","radioSize":"Input_radioSize__q7cdu"};